import { render } from "./index.vue?vue&type=template&id=d978c022&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d978c022&scoped=true&lang=css"

import exportComponent from "C:\\Users\\zhang\\Desktop\\loan\\loanweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d978c022"]])

export default __exports__